module.exports = __webpack_public_path__ + "static/media/bg-left.0efcb2e9.png";